import { useCallback, useEffect, useState } from "react"
declare const window: any;

const ReCaptcha = (props: any) => {

    const [token, setToken] = useState("");

    const generateToken = useCallback(() => {
        try {
            window.grecaptcha
                .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: props.action })
                .then((token: any) => {
                    setToken(token);
                });
        } catch (e) { }
        console.log(props.reCaptchaTimestamp);
    }, [props.action, props.reCaptchaTimestamp]);

    const handleLoaded = useCallback(() => {
        window.grecaptcha.ready(() => {
            generateToken();
        })
    }, [generateToken]);

    useEffect(() => {
        props.onToken(token);
    }, [props, token]);

    useEffect(() => {
        generateToken();
    }, [generateToken, props.reCaptcha]);

    useEffect(() => {
        const script = document.createElement("script")
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`
        script.addEventListener("load", handleLoaded)
        document.body.appendChild(script);
    }, [handleLoaded]);

    return (
        <div
            className="g-recaptcha"
            data-sitekey="_reCAPTCHA_site_key_"
            data-size="invisible"
        ></div>
    )
};

export default ReCaptcha;